module.exports = __webpack_public_path__ + "img/arrow_down2.5ea1fa13.svg";